import ImportJobCatalogInProgress from 'modules/job_catalog/components/ImportJobCatalogInProgress'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const JobCatalogTreeImportInProgressPage = () => {
  return (
    <ResponsivePage.Body showHeader={false}>
      <ImportJobCatalogInProgress />
    </ResponsivePage.Body>
  )
}

export default JobCatalogTreeImportInProgressPage
